import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  repo: z.string().min(1),
  path: z.string().min(1),
  branch: z.string().optional(),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  name: string;
  path: string;
  sha: string;
  size: number;
  content: string;
  encoding: string;
};

export const getGithubFile = async (input: InputType, init?: RequestInit): Promise<OutputType> => {
  const params = new URLSearchParams();
  params.set('repo', input.repo);
  params.set('path', input.path);
  if (input.branch) params.set('branch', input.branch);

  const result = await fetch(`/_api/github/file?${params.toString()}`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });

  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
